import { fetchThemesData } from '../actions/routines';
import { call, put } from 'redux-saga/effects';
import Products from '../services/api/Products';

export function* fetchThemesSaga(action) {
    try {
        yield put(fetchThemesData.request());

        const response = yield call(Products.getThemes, action.payload);

        yield put(fetchThemesData.success(response.data));
    } catch (error) {
        yield put(fetchThemesData.failure(error.message));
    } finally {
        yield put(fetchThemesData.fulfill());
    }
}
